import { useEffect, useState } from 'react';

const getLastSlideLength = (slides) => slides.length ? slides[slides.length - 1]
    .filter(item => Boolean(item)).length : 0;

export const useGamesSliders = ({ slides, isIntersecting }) => {
    const partSize = 3;
    const loadSize = 6;
    const [gamesSliders, setGamesSliders] = useState([]);
    const [previousSlideLength, setPreviousSlideLength] = useState(slides.length ? slides[0].length : 0);
    const [lastSlideLength, setLastSlideLength] = useState(getLastSlideLength(slides));
    const [allSlides, setAllSlides] = useState(false);

    useEffect(() => {
        if (slides?.length && slides.length <= partSize && slides[0].length === previousSlideLength) {
            setGamesSliders(slides);
        } else if (slides?.length
            && slides.length !== gamesSliders.length
            && slides[0].length === previousSlideLength) {
            setGamesSliders(slides.slice(0, partSize));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);

    useEffect(() => {
        if (slides.length === gamesSliders.length) {
            setAllSlides(true);
        }
    }, [slides, gamesSliders]);

    useEffect(() => {
        if (isIntersecting && slides?.length && gamesSliders.length !== slides.length) {
            setGamesSliders((prevGamesSliders) => [
                ...prevGamesSliders,
                ...slides.slice(prevGamesSliders.length, prevGamesSliders.length + loadSize)
            ]);
        }
    }, [isIntersecting, slides, gamesSliders]);

    useEffect(() => {
        if (slides?.length && slides[0].length !== previousSlideLength) {
            setPreviousSlideLength(slides[0].length);
            setGamesSliders((prevGamesSliders) => allSlides ? slides : slides.slice(0, prevGamesSliders.length));
        } else if (slides?.length && getLastSlideLength(slides) !== lastSlideLength) {
            setLastSlideLength(getLastSlideLength(slides));
            setGamesSliders((prevGamesSliders) => allSlides ? slides : slides.slice(0, prevGamesSliders.length));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides, allSlides, previousSlideLength]);

    return gamesSliders;
};
